import React, { useState } from 'react';

/**
 * Shows a user's photo if available, otherwise a colored circle with initials.
 * Props:
 *   photoUrl  — remote image URL (optional)
 *   name      — display name used for initials fallback
 *   size      — px size (default 40)
 *   className — extra CSS class
 */
const COLORS = [
  '#6e3ff4', '#e04bf7', '#3f8ef4', '#f4a33f',
  '#3fe4a3', '#f43f6e', '#a3f43f', '#f4e03f',
];

function colorForName(name = '') {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return COLORS[Math.abs(hash) % COLORS.length];
}

function initials(name = '') {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase() || '?';
}

const UserAvatar = ({ photoUrl, name = '', size = 40, className = '' }) => {
  const [imgFailed, setImgFailed] = useState(false);

  const style = {
    width: size,
    height: size,
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: size * 0.35,
    fontWeight: 700,
    color: '#fff',
  };

  if (photoUrl && !imgFailed) {
    return (
      <div style={style} className={className}>
        <img
          src={photoUrl}
          alt={name}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          onError={() => setImgFailed(true)}
        />
      </div>
    );
  }

  return (
    <div style={{ ...style, background: colorForName(name) }} className={className}>
      {initials(name)}
    </div>
  );
};

export default UserAvatar;
